(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["circal-colletion"] && !Shopify.designMode) return;
  try {
    
(function() {
  document.querySelectorAll('[id^="circleCatsTrack-"]').forEach(function(track) {
    var sectionSuffix = track.id.replace('circleCatsTrack-', '');
    var dotsContainer = document.getElementById('circleCatsDots-' + sectionSuffix);
    var items = track.querySelectorAll('.circle-cats__item');
    if (!items.length) return;

    var currentIndex = 0;
    var autoTimer = null;
    var autoDelay = 2500; // ms between slides

    // ── How many items fit in view? ──
    function visibleCount() {
      var wrapWidth = track.parentElement.offsetWidth;
      var itemWidth = items[0].offsetWidth + 12; // gap = 12px
      return Math.max(1, Math.floor(wrapWidth / itemWidth));
    }

    // ── Max index we can slide to ──
    function maxIndex() {
      return Math.max(0, items.length - visibleCount());
    }

    // ── Build dots ──
    function buildDots() {
      dotsContainer.innerHTML = '';
      var total = maxIndex() + 1;
      for (var i = 0; i < total; i++) {
        var btn = document.createElement('button');
        btn.className = 'circle-cats__dot' + (i === currentIndex ? ' active' : '');
        btn.setAttribute('aria-label', 'Slide ' + (i + 1));
        (function(idx) {
          btn.addEventListener('click', function() { goTo(idx); resetTimer(); });
        })(i);
        dotsContainer.appendChild(btn);
      }
    }

    // ── Update active dot ──
    function updateDots() {
      var dots = dotsContainer.querySelectorAll('.circle-cats__dot');
      dots.forEach(function(d, i) {
        d.classList.toggle('active', i === currentIndex);
      });
    }

    // ── Slide to index ──
    function goTo(idx) {
      currentIndex = Math.min(Math.max(0, idx), maxIndex());
      var itemWidth = items[0].offsetWidth + 12;
      track.style.transform = 'translateX(-' + (currentIndex * itemWidth) + 'px)';
      updateDots();
    }

    // ── Auto advance ──
    function startTimer() {
      autoTimer = setInterval(function() {
        var next = currentIndex >= maxIndex() ? 0 : currentIndex + 1;
        goTo(next);
      }, autoDelay);
    }

    function resetTimer() {
      clearInterval(autoTimer);
      startTimer();
    }

    // ── Touch / swipe support ──
    var touchStartX = 0;
    track.addEventListener('touchstart', function(e) {
      touchStartX = e.touches[0].clientX;
      clearInterval(autoTimer);
    }, { passive: true });

    track.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? currentIndex + 1 : currentIndex - 1);
      }
      startTimer();
    }, { passive: true });

    // ── Recalculate on resize ──
    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        buildDots();
        goTo(0);
      }, 200);
    });

    // ── Init ──
    buildDots();
    goTo(0);
    startTimer();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
